module.exports = __webpack_public_path__ + "img/AIGC_icon1.d6ae2bf7.png";